import { IPosition } from 'shared-types/SharedTypes';
import { IFastBookingCard } from 'floorplan-v2/app/services/floorplanNonReduxState/types';
import appStartService from 'floorplan-v2/app/services/appStart/appStartService';
import { APP_STATUS } from 'floorplan-v2/app/services/appStart/types';
import AppStartService from 'floorplan-v2/app/services/appStart/appStartService';

const NS = 'FloorplanNonReduxState';

/**
 * This service handles state management for some edge cases that redux wasn't suited for.
 */

class FloorplanNonReduxState {
  private draggableBookingCoords: IPosition;
  private isDragPanning: boolean;
  private disableLeftScroll: boolean;
  private fastBookingCardCallback: (fastBookingCard: IFastBookingCard) => void;
  private rerenderCallback: (tableIds?: string[]) => void;
  private fastBookingCardListHoverBookingId: string;

  setDraggableBookingCoords(value: IPosition) {
    this.draggableBookingCoords = value;
  }

  getDraggableBookingCoords(): IPosition {
    return this.draggableBookingCoords;
  }

  setIsDragPanning(value: boolean) {
    this.isDragPanning = value;
  }
  getIsDragPanning(): boolean {
    return this.isDragPanning;
  }

  setFastBookingCard(value: IFastBookingCard): void {
    if (this.fastBookingCardCallback) {
      this.fastBookingCardCallback(value);
    }
  }

  setFastBookingCardCallback(cb: (fastBookingCard: IFastBookingCard) => void): void {
    this.fastBookingCardCallback = cb;
  }
  setDisableLeftScroll(value: boolean): void {
    this.disableLeftScroll = value;
  }
  getDisableLeftScroll(): boolean {
    return this.disableLeftScroll;
  }

  setFastBookingCardListHoverBookingId(bookingId: string, tableId?: string): void {
    // only if the FP is active that the hover feature is allowed
    if (appStartService.getAppStatus() === APP_STATUS.active) {
      this.fastBookingCardListHoverBookingId = bookingId;
      if (tableId) {
        this.forceRerender([tableId]);
      } else {
        this.forceRerender();
      }
    }

  }

  getFastBookingCardListHoverBookingId(): string {
    return this.fastBookingCardListHoverBookingId;
  }

  forceRerender(tableIds?: string[]) : void {
    if (this.rerenderCallback) {
      this.rerenderCallback(tableIds);
    }
  }

  setRerenderCallback(cb: (tableIds?: string[]) => void): void {
    this.rerenderCallback = cb;
  }
}

const instance = new FloorplanNonReduxState();
export default instance as FloorplanNonReduxState;
